export const PRIMARY = "#31f6a9";

export const SECONDARY = "#373737";

export const TEXT_COLOR = SECONDARY;


// WEBPACK FOOTER //
// ./src/styles.js